// Modelled after rxjs Subject
// https://medium.com/globant/rxjs-subjects-the-complete-know-how-3dc1e7e341a0

import { logger } from '@accedo/logger';
import { ListenerData } from './types';

export type Options = {
  appSubSection3?: string;
  showId?: string;
  showName?: string;
  showGenre?: string;
  appSubSection1?: string;
};

export class Messenger<T> {
  private listeners: {
    id: number;
    action: (data: T, options?: Options) => void;
  }[] = [];

  private counter = 1;
  private state: T;
  private initialValue: T;

  constructor(initialValue: T) {
    this.state = initialValue;
    this.initialValue = initialValue;
  }

  addReceiver(
    action: (data: T, options?: Options) => void,
    immediatelySendData = false,
  ): ListenerData<T> {
    const id = this.getNewId();
    this.listeners.push({ action, id });
    if (immediatelySendData) {
      action(this.state);
    }
    return { receiver: id, messenger: this };
  }

  removeReceiver(receiver: number | ((data: T) => void)): void {
    const foundId = this.listeners.find(
      (listener) => listener.id === receiver || listener.action === receiver,
    );
    if (!foundId) {
      logger.warn('No message receiver found to unlisten');
    }
    this.listeners = this.listeners.filter(
      (listener) => listener.id !== receiver && listener.action !== receiver,
    );
  }

  send(data: T, options?: Options): void {
    this.state = data;
    this.listeners.forEach((listener) => listener.action(data, options));
  }

  getCurrentValue(): T {
    return this.state;
  }

  resetToDefault(): void {
    this.send(this.initialValue);
  }

  private getNewId(): number {
    this.counter += 1;
    return this.counter;
  }
}
